/**
 * internal dependencies
 */
import { PIN_POOL_FORM } from '../form-cardgroup-types';
import { usePinPool } from './pin-pool-helpers';

import { IPinPool } from '../../../../models/cardgroup.interface';
import { pinPoolWidget } from '../../../widgets/pinPoolWidget';

import ExportCsv from '../csv/export-csv';

/**
 * Displays the pin pool for a card group
 * 
 * @param {IPinPool} data - The pin pool data
 * 
 * @returns void
 */
export const displayPinPool = (data: IPinPool) => { 
  const { cardGroup, pinPool } = data.body;
  const { customerId, customerName, cardGroupName,cardGroupId } = cardGroup[0];

  const { ppCustomerName, ppCardGroupName, ppActive, ppFieldContainer } = PIN_POOL_FORM;

  ppCustomerName.value = customerName ?? '';
  ppCustomerName.dataset.customerId = customerId.toString() ?? '';
  ppCardGroupName.value = cardGroupName ?? '';
  ppCardGroupName.dataset.cardGroupId = cardGroupId?.toString() ?? '';
  
  if (pinPool.length > 0) {
    ppActive.checked = pinPool[0].validate === '1' ? true : false;
  } 

  usePinPool(ppActive)
  ppActive.addEventListener('click', () => usePinPool(ppActive));

  pinPoolWidget(pinPool, ppFieldContainer);

  PIN_POOL_FORM.ppExport.addEventListener('click', () => {
    PIN_POOL_FORM.ppExport.classList.add('aafp_button-loading');
    ExportCsv(data, 'pin_pool');
  });
};